import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { requestApi } from '~/services/api.js';
import useScreenOrientation from '~/hooks/use-orientation.js';
import { showNotification } from '~/components/notifications/ducks/notifications.js';
import { gettoolbarLeftMargin } from '~/components/casino-shared/game-loader/ducks/toolbar-utils';

import { API_IDLE, API_LOADING, API_SUCCESS, API_ERROR } from './constants.js';

export const useInstantDepositInfo = () => {
	const [error, setError] = useState(null);
	const [depositInfo, setDepositInfo] = useState(null);
	const [depositInfoStatus, setDepositInfoStatus] = useState(API_IDLE);

	const execute = useCallback(async () => {
		setDepositInfoStatus(API_LOADING);
		setError(null);

		try {
			const response = await requestApi('/PaymentFormDataService/getInstantDepositInfo');
			if (response.status === 'success') {
				setDepositInfo({
					...response
				});
				setDepositInfoStatus(API_SUCCESS);
			} else {
				setError(response.errorMessage);
				setDepositInfoStatus(API_ERROR);
			}
		} catch (e) {
			console.warn('Instant Deposit Error!'); // eslint-disable-line
			setError(e);
			setDepositInfoStatus(API_IDLE);
		}
	}, []);

	useEffect(() => {
		execute();
	}, [execute]);

	return { depositInfo, depositInfoStatus, error };
};

export const useQDNotifications = () => {
	const dispatch = useDispatch();
	const screenOrientation = useScreenOrientation();
	const showErrorNotification = useCallback(
		message =>
			dispatch(
				showNotification({
					message,
					color: 'red',
					autoHide: true,
					customMargin: gettoolbarLeftMargin(screenOrientation)
				})
			),
		[dispatch, screenOrientation]
	);
	return { showErrorNotification };
};
